export const isNetworkError = (error?: Error) => error && /network error/i.test(error.message)
